import HttpAccessor from "./HttpAccessor";

class HttpStore extends HttpAccessor {
  constructor(http, path, paramReducer, responseType) {
    super(http, path, paramReducer);
    this._responseType = responseType;
  }

  async store(obj, headers) {
    let response = await this._http.request({
      method: "post",
      url: this._path,
      responseType: this._responseType,
      data: obj,
      headers: headers,
    });

    return response.data;
  }
}

export default HttpStore;
